import { TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ThaiDatepickerService extends NgbDatepickerI18n {
  private shortMonths = [
    'ม.ค.',
    'ก.พ.',
    'มี.ค.',
    'เม.ย.',
    'พ.ค.',
    'มิ.ย.',
    'ก.ค.',
    'ส.ค.',
    'ก.ย.',
    'ต.ค.',
    'พ.ย.',
    'ธ.ค.',
  ];

  private weekdaysShort = ['จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.', 'อา.'];

  override getMonthShortName(month: number): string {
    return this.shortMonths[month - 1];
  }

  override getMonthFullName(month: number): string {
    return this.shortMonths[month - 1];
  }

  override getYearNumerals(year: number): string {
    // Clamp Gregorian year to range 1957-2025
    const clampedGregorian = Math.min(Math.max(year, 1957), 2025);
    // Convert to Thai Buddhist year
    const thaiYear = clampedGregorian + 543;
    return String(thaiYear);
  }

  override getDayAriaLabel(date: NgbDateStruct): string {
    const clampedGregorian = Math.min(Math.max(date.year, 1957), 2025);
    const thaiYear = clampedGregorian + 543;
    return `${date.day}-${date.month}-${thaiYear}`;
  }

  override getWeekdayLabel(weekday: number, width: TranslationWidth): string {
    return this.weekdaysShort[weekday - 1];
  }
}
